import React from 'react';
import GalleryContainer from '../components/gallery/GalleryContainer';
import './Widget.scss';

const WidgetContainer = () => {
	return <GalleryContainer />;
};

export default WidgetContainer;
